import * as Yup from "yup";
export var validationSchema = Yup.object({
    username: Yup.string().required(),
});
